import { useEffect, useState } from "react"

export default function useClientOnly() {
  const [client, setClient] = useState(false)
  useEffect(() => {
    setClient(true)
  }, [])
  return client
}
